module.exports = __webpack_public_path__ + "media/images/iconPaginatePrev__errorRed--dark-fa635b734ab39a3937a95a5ef513c9c8.png";